import { updateERAReport } from '../../../../packages/neb-api-client/src/era-report-api-client';
import { ERA_ACTIONS } from '../../../utils/era-eob';

export default ({ claimReportId, lineItemReportId, model: { id } }) =>
  updateERAReport(id, {
    eraAction: ERA_ACTIONS.MERGE_LINE_ITEMS,
    claimReportId,
    lineItemReportId,
  });
